var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FFE7E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4978 28.6667H13.9654C12.2856 28.6667 11.4458 28.6667 11.269 28.5364C11.0705 28.39 11.022 28.3036 11.0005 28.0581C10.9814 27.8396 11.4961 26.9981 12.5257 25.3155C13.5886 23.578 14.4912 21.0483 14.4912 17.4667C14.4912 15.4864 15.335 13.5872 16.8369 12.1869C18.3389 10.7867 20.3759 10 22.5 10C24.624 10 26.6611 10.7867 28.163 12.1869C29.665 13.5872 30.5087 15.4864 30.5087 17.4667C30.5087 21.0483 31.4113 23.578 32.4744 25.3155C33.5037 26.9981 34.0186 27.8396 33.9995 28.0581C33.978 28.3036 33.9294 28.39 33.7309 28.5364C33.5542 28.6667 32.7144 28.6667 31.0346 28.6667H26.5044M18.4978 28.6667L18.4956 30C18.4956 32.2092 20.2885 34 22.5 34C24.7116 34 26.5044 32.2092 26.5044 30V28.6667M18.4978 28.6667H26.5044",
    stroke: "#D12E0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3657ec495a89ec493a5a34ec29599d08.svg";
export { ForwardRef as ReactComponent };